import { render } from "./fsRaceSignInfo.vue?vue&type=template&id=878e841a&scoped=true"
import script from "./fsRaceSignInfo.vue?vue&type=script&lang=js"
export * from "./fsRaceSignInfo.vue?vue&type=script&lang=js"

import "./fsRaceSignInfo.vue?vue&type=style&index=0&id=878e841a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-878e841a"]])

export default __exports__